import React, { useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { LockOutlined } from "@mui/icons-material";
import { getUserById } from "../../redux/actions/user.dispatcher";
import {
  ConfirmationSnackbar,
} from "../../components/Common/CustomSnackbar";
import ResetPasswordModal from "./ResetPasswordModal";
import {
  SecurityCard,
  SecurityCardTitle,
  SecurityCardSubtitle,
  PasswordRow,
  PasswordIconBox,
  PasswordInfo,
  PasswordLabel,
  PasswordDate,
  ResetPasswordBtn,
} from "./Settings.styles";

const formatDate = (dateStr) => {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return null;
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

const SecurityTab = () => {
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.user);

  const [modalOpen, setModalOpen] = useState(false);
  const [success, setSuccess] = useState(false);

  const lastChanged = formatDate(userData?.passwordChangedAt);

  const handleSuccess = useCallback(() => {
    setSuccess(true);
    // Refresh user data so passwordChangedAt updates
    dispatch(getUserById());
  }, [dispatch]);

  return (
    <>
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setSuccess(false)}
        text="Password has been changed successfully!"
      />

      <ResetPasswordModal
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
        onSuccess={handleSuccess}
      />

      <SecurityCard>
        <SecurityCardTitle>Security</SecurityCardTitle>
        <SecurityCardSubtitle>
          Manage your password and security settings
        </SecurityCardSubtitle>

        <PasswordRow>
          <PasswordIconBox>
            <LockOutlined />
          </PasswordIconBox>

          <PasswordInfo>
            <PasswordLabel>Password</PasswordLabel>
            {lastChanged && (
              <PasswordDate>Last changed: {lastChanged}</PasswordDate>
            )}
          </PasswordInfo>

          <ResetPasswordBtn onClick={() => setModalOpen(true)}>
            Reset Password
          </ResetPasswordBtn>
        </PasswordRow>
      </SecurityCard>
    </>
  );
};

export default SecurityTab;
